export const CompanyDataReducer = (state: any, action: any) => {
    switch(action.type) {
        default:
            return {
                ...state
            }
    }
}